import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import ProductBoxDark from './ProductBoxDark';
import classes from './FavoriteProducts.module.css';

const responsive = {
  veryWideScreen: {
    breakpoint: { max: 4800, min: 1900 },
    items: 5,
    slidesToSlide: 4,
  },
  wideScreen: {
    breakpoint: { max: 1900, min: 1360 },
    items: 4,
    slidesToSlide: 3,
  },
  desktop: {
    breakpoint: { max: 1360, min: 1199 },
    items: 3,
    slidesToSlide: 2,
  },
  smallDesktop: {
    breakpoint: { max: 1199, min: 1024 },
    items: 3,
    slidesToSlide: 2,
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 2,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 768, min: 0 },
    items: 1,
    slidesToSlide: 3,
  },
};

const products = [
  { id: 1, image: 'img/products/25-euro-amazon-gutschein.svg', link: '/produkt/25-euro-amazon-gutschein', name: 'Amazon 25 Euro' },
  { id: 2, image: 'img/products/paysafecard-10-euro.svg', link: '/produkt/paysafe-10-euro', name: 'Paysafe 10 Euro' },
  { id: 3, image: 'img/products/google-play-50-euro.svg', link: '/produkt/google-play-50-euro', name: 'Google Play 50 Euro' },
  { id: 4, image: 'img/products/paysafecard-50-euro.svg', link: '/produkt/paysafe-50-euro', name: 'Paysafe 50 Euro' },
  { id: 5, image: 'img/products/xbox-25-euro.svg', link: '/produkt/xbox-25-euro', name: 'Xbox 25 Euro' },
  { id: 6, image: 'img/products/zalando-10-euro.svg', link: '/produkt/zalando-10-euro', name: 'Zalando 10 Euro' },
  { id: 7, image: 'img/products/steam-50-euro.svg', link: '/produkt/steam-50-euro.svg', name: 'Steam 50 Euro' },
  { id: 8, image: 'img/products/spotify-30-euro.svg', link: '/produkt/spotify-30-euro.svg', name: 'Spotify 30 Euro' },
  { id: 9, image: 'img/products/nintendo-15-euro.svg', link: '/produkt/nintendo-15-euro', name: 'Nintendo 15 Euro' },
  { id: 10, image: 'img/products/paysafecard-20-euro.svg', link: '/produkt/paysafe-20-euro', name: 'Paysafe 20 Euro' },
];

export default function MoreFavoriteProducts() {
  return (
    <Carousel responsive={responsive} centerMode={true} infinite={true}  arrows={true}  swipeable={true} draggable={true} keyBoardControl={true} customTransition="transform 500ms ease-in-out" transitionDuration={1000} containerClass={classes.carouselContainer} removeArrowOnDeviceType={["smallDesktop","tablet", "mobile"]}>
      {products.map(product => (
              <ProductBoxDark key={product.id} image={product.image} link={product.link} alt={product.name} />
            ))}
    </Carousel>
  )
}

